import {clientPostWrapper} from "../api/Api";
import {CREATE_NEW_USER} from "../common/constants/routes";



export const createNewUser = (user) => {
    return clientPostWrapper(CREATE_NEW_USER, user)
}
